import { render, staticRenderFns } from "./listDetail.vue?vue&type=template&id=d385a704&scoped=true&"
import script from "./listDetail.vue?vue&type=script&lang=ts&"
export * from "./listDetail.vue?vue&type=script&lang=ts&"
import style0 from "./listDetail.vue?vue&type=style&index=0&id=d385a704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d385a704",
  null
  
)

export default component.exports